import { Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import RefuseSelect from '../RefuseSelect';
import './styles.scss';
import { VehicleImage } from './VehicleImage';
const VehiclePhotos: React.FC = () => {
  const driver = useSelector((state: ApplicationState) => state.driver);

  return (
    <div>
      <div className="btn-refuse-image">
        {driver.vehicle?.backVehicle?.length > 0 ? (
          <VehicleImage url={driver.vehicle?.backVehicle} />
        ) : (
          <NoImageMessage />
        )}
        <RefuseSelect step={6} />
      </div>
      <div className="btn-refuse-image">
        {driver.vehicle?.frontVehicle?.length > 0 ? (
          <VehicleImage url={driver.vehicle?.frontVehicle} />
        ) : (
          <NoImageMessage />
        )}
        <RefuseSelect step={7} />
      </div>
      <div className="btn-refuse-image">
        {driver.vehicle?.leftVehicle?.length > 0 ? (
          <VehicleImage url={driver.vehicle?.leftVehicle} />
        ) : (
          <NoImageMessage />
        )}
        <RefuseSelect step={8} />
      </div>

      <div className="btn-refuse-image">
        {driver.vehicle?.rightVehicle?.length > 0 ? (
          <VehicleImage url={driver.vehicle?.rightVehicle} />
        ) : (
          <NoImageMessage />
        )}
        <RefuseSelect step={9} />
      </div>
    </div>
  );
};

function NoImageMessage() {
  return (
    <div className=" vehicle-image-container">
      <Typography variant="body1">Sem imagem</Typography>
    </div>
  );
}

export default VehiclePhotos;
